import user from './user'
import manager from './manager'

const home = {
  path: '',
  component: resolve => require(['../../pages/home'], resolve),
  children: [
    ...user,
    manager
  ]
}

export default home
